<template>
  <div>
    <div v-if="data" id="print-area" class="ticket">
      <h4>{{ brand.nombreCorto }}</h4>
      <p class="text-center">Cierre de Caja</p>
      <p class="text-center">
        <template v-if="$route.query.fecha_inicio">
          {{ $route.query.fecha_inicio.slice(0, 16) }} →
          {{ $route.query.fecha_fin.slice(0, 16) }}
        </template>
        <template v-else>{{ formatearFecha($route.query.fecha) }}</template>
      </p>
      <p class="text-center">
        Generado por: {{ user?.Nombres }} {{ user?.Apellidos }}
      </p>
      <hr />

      <p><strong>INGRESOS</strong></p>
      <p>Hospedaje: Q{{ Number(data.ingresos.hospedaje).toFixed(2) }}</p>
      <p>
        Servicios Extra: Q{{ Number(data.ingresos.servicios_extra).toFixed(2) }}
      </p>
      <p>Restaurante: Q{{ Number(data.ingresos.restaurante).toFixed(2) }}</p>
      <p>
        <strong
          >Total Ingresos: Q{{
            Number(data.ingresos.total_general).toFixed(2)
          }}</strong
        >
      </p>

      <hr />
      <p><strong>PAGOS</strong></p>
      <template v-if="Object.keys(data.pagos).length > 0">
        <template v-for="(metodos, tipo) in data.pagos" :key="tipo">
          <p>
            <u>{{ tipo }}</u>
          </p>
          <template v-for="(monto, metodo) in metodos" :key="metodo">
            <p>- {{ metodo }}: Q{{ Number(monto).toFixed(2) }}</p>
          </template>
        </template>
      </template>
      <template v-else>
        <p>Sin pagos registrados</p>
      </template>

      <hr />
      <p><strong>TOTAL PAGOS</strong></p>
      <p>
        Facturado: Q{{ Number(data.resumen_pagos.total_facturado).toFixed(2) }}
      </p>
      <p>
        No Facturado: Q{{
          Number(data.resumen_pagos.total_no_facturado).toFixed(2)
        }}
      </p>
      <p>
        <strong
          >Total Pagos: Q{{
            Number(data.resumen_pagos.total_pagos).toFixed(2)
          }}</strong
        >
      </p>

      <hr />
      <p><strong>CUADRE</strong></p>
      <p>Diferencia: Q{{ Number(data.diferencia).toFixed(2) }}</p>
      <p>Estado: {{ data.estado_cuadre }}</p>

      <hr />
      <p>
        <strong>Huéspedes Ingresados:</strong> {{ data.huespedes_ingresados }}
      </p>
      <hr />

      <div class="no-print text-center">
        <button class="btn btn-dark w-100" @click="imprimir">🖨 Imprimir</button>
      </div>
    </div>

    <div v-else class="text-center text-muted my-4 no-print">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Cargando cierre de caja para imprimir...</p>
    </div>
  </div>
</template>

<script>
import axios from "@/config/axios";
import { API_URL } from "@/config/config";
import { mapState } from "vuex";
import { BRAND } from "@/config/branding";

export default {
  name: "ImprimirCierreCaja",
  data() {
    return {
      brand: BRAND,
      data: null,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  async mounted() {
    const fechaInicio = this.$route.query.fecha_inicio;
    const fechaFin = this.$route.query.fecha_fin;
    const fechaLegacy = this.$route.query.fecha;
    const params =
      fechaInicio && fechaFin
        ? { fecha_inicio: fechaInicio, fecha_fin: fechaFin }
        : { fecha: fechaLegacy || new Date().toLocaleDateString("fr-CA") };
    try {
      const res = await axios.get(`${API_URL}/cierre-caja`, { params });
      this.data = res.data;
    } catch (err) {
      console.error("Error cargando cierre de caja:", err);
    }
  },
  methods: {
    imprimir() {
      const area = document.getElementById("print-area").cloneNode(true);
      const button = area.querySelector(".no-print");
      if (button) button.remove();

      const w = window.open("", "", "width=300,height=600");

      const style = `
    <style>
      * {
        font-size: 13px;
        font-family: monospace;
        line-height: 1.2;
        margin: 0;
        padding: 0;
      }
      body {
        padding: 10px;
        width: 260px;
      }
      h4, p {
        text-align: center;
        margin-bottom: 6px;
      }
      p {
        text-align: left;
        margin: 4px 0;
      }
      hr {
        border: none;
        border-top: 1px dashed #000;
        margin: 6px 0;
      }
    </style>
  `;

      w.document.write(`
    <html>
      <head><title>Impresión</title>${style}</head>
      <body>${area.innerHTML}</body>
    </html>
  `);

      w.document.close();
      w.focus();
      w.print();
      w.close();
    },
    formatearFecha(fecha) {
      return fecha.split("-").reverse().join("/");
    },
  },
};
</script>

<style scoped>
.ticket {
  width: 300px;
  margin: 0 auto;
  font-family: monospace;
  font-size: 13px;
  line-height: 1.2;
}

.no-print {
  margin-top: 10px;
}

@media print {
  .no-print {
    display: none !important;
  }
}
</style>
